import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const MobileForm = ({ isOpen, onClose, onSubmit, circlename, operatorname }) => {
  const [operator, setOperator] = useState(operatorname ? operatorname : "JIO");
  const [circle, setCircle] = useState(circlename ? circlename : "DELHI");
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ operator, circle });
  };
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-[999]"
      onClick={onClose}
    >
      <div
        className="ds-card w-[350px] max-w-[92vw] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-[var(--text-muted)] hover:text-[var(--error-color)] transition"
        >
          <CloseIcon fontSize="small" />
        </button>
        <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-4 text-left whitespace-nowrap pr-8">
          Choose Mobile Operator & Circle
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="ds-label">
              Operator <span className="text-[var(--error-color)]">*</span>
            </label>
            <select
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
              className="ds-input"
            >
              <option>Jio</option>
              <option>Airtel</option>
              <option>BSNL</option>
              <option>Idea</option>
              <option>Vodafone</option>
              <option>MTNL Delhi</option>
              <option>MTNL Mumbai</option>
            </select>
          </div>
          <div>
            <label className="ds-label">
              Network Circle<span className="text-[var(--error-color)]">*</span>
            </label>
            <select
              value={circle}
              onChange={(e) => setCircle(e.target.value)}
              className="ds-input"
            >
              <option>Delhi NCR</option>
              <option>Assam</option>
              <option>Haryana</option>
              <option>Jammu Kashmir</option>
              <option>UP East</option>
              <option>Punjab</option>
            </select>
          </div>
          <button type="submit" className="ds-btn ds-btn-primary ds-btn-block">
            Select
          </button>
        </form>
      </div>
    </div>
  );
};
export default MobileForm;
